document.addEventListener("DOMContentLoaded", () => {
  const cartDrawer = document.getElementById("cart-drawer");
  const cartOverlay = document.getElementById("cart-drawer-overlay");
  const cartClose = document.getElementById("cart-drawer-close");
  const cartSubtotalIdEl = document.getElementById("cart-subtotal");
  const cartSubtotalEls = document.querySelectorAll(".cart-drawer-subtotal");
  const cartBody = document.querySelector(".cart-drawer-body");
  const cartButton = document.querySelector(".site-header-cart--button");
  const cartCountBubble = document.querySelector('.site-header-cart--count');
  const crossSellDrawer = document.getElementById("cross-sell-drawer");
  const cartDrawerFooter = document.querySelector(".cart-drawer-footer");

  const wishlistPopup = document.querySelector('.wishlist-confirmation-popup');
  const wishlistPopupOverlay = document.querySelector('.wishlist-overlay');
  const wishlistPopupClose = document.querySelector('.wishlist-confirmation-close');
  const confirmMoveBtn = document.querySelector('.confirm-move-to-wishlist');
  const confirmRemoveBtn = document.querySelector('.confirm-remove-item');

  const deleteIconEnable = document.querySelector('.all-items-delete-btn');
  const wishlistEnable = document.querySelector('.all-items-wishlist-btn');

  const deleteConfirmPopup = document.querySelector('.delete-confirmation-popup');
  const deleteConfirmClosePopup = document.querySelector('.removepopup-close-btn');

  let currentItemKey = null;
  let selectedItemData = null;

  async function openWishlistPopup(itemKey, handle) {
    currentItemKey = itemKey;

    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) throw new Error('Failed to fetch product data');
      selectedItemData = await res.json();
    } catch (err) {
      console.error('Error fetching product data:', err);
      selectedItemData = null;
    }

    wishlistPopup.style.display = 'block';
    wishlistPopupOverlay.classList.add("active");
    document.body.classList.add('overflow-hidden');

    if (confirmRemoveBtn) {
      confirmRemoveBtn.setAttribute('data-key', itemKey);
    }
  }

  function closeWishlistPopup() {
    wishlistPopup.style.display = 'none';
    wishlistPopupOverlay.classList.remove("active");
    document.body.classList.remove('overflow-hidden');
    currentItemKey = null;
    selectedItemData = null;
  }

  wishlistPopupClose?.addEventListener('click', closeWishlistPopup);
  wishlistPopupOverlay?.addEventListener('click', function (event) {
    if (event.target === wishlistPopupOverlay) {
      closeWishlistPopup();
    }
  });

  async function fetchAndUpdateCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      updateCartHTML(cart);
    } catch (err) {
      console.error("Failed to fetch cart:", err);
    }
  }

  function openCartDrawer() {
    cartDrawer.classList.add("active");
    cartDrawer.classList.remove("hidden");
    cartOverlay.classList.add("active");
    cartOverlay.classList.remove("hidden");
    document.body.classList.add("overflow-hidden");

    if (crossSellDrawer) {
      crossSellDrawer.classList.add("active");
      crossSellDrawer.classList.remove("hidden");
    }

    fetchAndUpdateCart();
  }

  function closeCartDrawer() {
    cartDrawer.classList.remove("active");
    cartDrawer.classList.add("hidden");
    cartOverlay.classList.remove("active");
    cartOverlay.classList.add("hidden");
    document.body.classList.remove("overflow-hidden");

    if (crossSellDrawer) {
      crossSellDrawer.classList.remove("active");
      crossSellDrawer.classList.add("hidden");
    }
  }

  function updateCartHTML(cart) {
    const cartDrawerBody = document.querySelector('.cart-drawer-body');
    const upsellTemplateEl = document.getElementById('upsell-template');
    const upsellClone = upsellTemplateEl?.firstElementChild?.cloneNode(true);
    const isMobile = window.innerWidth <= 767;
  
    const itemsHtml = cart.items.map(item => {
      let variantText = '';
      if (item.options_with_values && Array.isArray(item.options_with_values)) {
        const variantOption = item.options_with_values.find(opt => opt.name === 'Variant');
        if (variantOption) {
          variantText = `<p class="cart-item-variant">${variantOption.value}</p>`;
        }
      }
  
      const productData = {
        handle: item.handle || '',
        id: item.product_id || '',
        title: item.product_title || '',
        featured_image: item.image || '',
        variants: [{
          id: item.variant_id || ''
        }]
      };
  
      return `
        <div class="cart-drawer-items" data-key="${item.key}">
          <div class="cart-item-left">
            <div class="cart-items-selects">
              <svg class="icon-select" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <circle cx="9" cy="9" r="9" fill="#CFCFCF"></circle>
                <path d="M12.557 6.75781L7.9524 11.2311L5.85938 9.1978" fill="#CFCFCF"></path>
                <path d="M12.557 6.75781L7.9524 11.2311L5.85938 9.1978" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              <svg class="icon-selectAll-active" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <circle cx="9" cy="9" r="9" fill="#221F20"></circle>
                <path d="M12.557 6.75781L7.9524 11.2311L5.85938 9.1978" fill="#221F20"></path>
                <path d="M12.557 6.75781L7.9524 11.2311L5.85938 9.1978" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </div>
            <img src="${item.image}" alt="${item.product_title}" class="cart-item-img" />
          </div>
          <div class="cart-item-right">
            <div class="cart-item-header">
            <a href="/products/${item.handle}">
              <p class="cart-item-title">${item.product_title}</p></a>
              ${variantText}
              <button class="cart-item-remove cart-remove-btn" data-key="${item.key}" data-product-handle="${item.handle}">&times;</button>
            </div>
            <div class="cart-item-options">
              <label>Qty:</label>
              <select class="cart-quantity-input" data-key="${item.key}">
                ${[...Array(10).keys()].map(i => `
                  <option value="${i + 1}" ${item.quantity === (i + 1) ? 'selected' : ''}>${i + 1}</option>
                `).join('')}
              </select>
              <div class="cart-item-price">₹${(item.final_line_price / 100).toFixed(2)}</div>
            </div>
          </div>
          <script type="application/json" data-product-json>
            ${JSON.stringify(productData)}
          </script>
        </div>
      `;
    }).join('');
  
    cartDrawerBody.innerHTML = itemsHtml;
    if (isMobile && upsellClone) {
      cartDrawerBody.appendChild(upsellClone);
      // rebindUpsellATCButtons();
    }
  
    const formattedSubtotal = (cart.total_price / 100).toLocaleString('en-IN', {
      style: 'currency', currency: 'INR'
    });
    cartSubtotalEls.forEach(el => el.textContent = formattedSubtotal);
    if (cartSubtotalIdEl) cartSubtotalIdEl.textContent = formattedSubtotal;
  
    updateCartCount();
  
    if (cart.item_count === 0) {
      cartDrawerFooter?.style.setProperty('display', 'none');
      crossSellDrawer?.style.setProperty('display', 'none');
    } else {
      cartDrawerFooter?.style.removeProperty('display');
      crossSellDrawer?.style.removeProperty('display');
    }
  
    bindCartItemEvents();
    bindSelectionEvents();
  }

  document.addEventListener('click', async function (e) {
    const button = e.target.closest('.product-custom-form--atc-button');
    if (!button) return;

    e.preventDefault();

    const variantId = button.getAttribute('data-variant-id');
    if (!variantId) {
      console.warn('Variant ID missing');
      return;
    }

    // Show loading state
    const originalText = button.innerHTML;
    button.innerHTML = 'Adding...';
    button.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (!res.ok) throw new Error('Failed to add to cart');

      // Fetch and update cart drawer
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      updateCartHTML(cart);

      // Show success notification
      showCartNotification('Product added to cart!');
    } catch (err) {
      console.error('Add to cart failed:', err);
      showCartNotification('Failed to add to cart. Try again.', true);
    } finally {
      button.innerHTML = originalText;
      button.disabled = false;
    }
  });

function showCartNotification(message, isError = false) {
    let notif = document.querySelector('#cart-notification');
    if (!notif) {
      notif = document.createElement('div');
      notif.id = 'cart-notification';
      document.body.appendChild(notif);
    }

    notif.textContent = message;
    notif.style.position = 'fixed';
    notif.style.bottom = 'auto';
    notif.style.top = '100px';
    notif.style.right = '20px';
    notif.style.padding = '12px 18px';
    notif.style.borderRadius = '6px';
    notif.style.fontSize = '14px';
    notif.style.zIndex = '9999';
    notif.style.backgroundColor = isError ? '#dc3545' : '#28a745';
    notif.style.color = 'white';
    notif.style.boxShadow = '0 2px 6px rgba(0, 0, 0, 0.2)';
    notif.style.opacity = '1';
    notif.style.transition = 'opacity 0.5s ease';

    setTimeout(() => {
      notif.style.opacity = '0';
      setTimeout(() => notif.remove(), 500);
    }, 2500);
  }


  function updateSelectedCount() {
    const drawerCount = document.querySelector('.cart-drawer-count');
    const allItems = document.querySelectorAll('.cart-items-selects');
    const selected = Array.from(allItems).filter(container => 
      container.classList.contains('active-item-icon')
    ).length;
  
    if (drawerCount) {
      const total = allItems.length;
      drawerCount.textContent = `${selected} / ${total}`;
      drawerCount.setAttribute('data-cart-drawer-count', `${selected}/${total}`);
    }
  }



  function updateCartCount() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      if (cartCountBubble) {
        cartCountBubble.textContent = cart.item_count;
        cartCountBubble.setAttribute('data-header-cart-count', cart.item_count);
        cartCountBubble.classList.toggle('visible', cart.item_count > 0);
      }
    })
    .catch(err => console.error('Failed to update cart count:', err));
}

// Call immediately once
  function bindCartItemEvents() {
    document.querySelectorAll('.cart-quantity-input').forEach(input => {
      input.addEventListener('change', async () => {
        const key = input.dataset.key;
        const quantity = parseInt(input.value);
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });
        const cart = await res.json();
        updateCartHTML(cart);
      });
    });

    document.querySelectorAll('.cart-remove-btn').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        const key = btn.dataset.key;
        const handle = btn.dataset.productHandle;
        openWishlistPopup(key, handle);
        closeCartDrawer();
      });
    });

    confirmRemoveBtn?.addEventListener('click', async () => {
      const key = confirmRemoveBtn.dataset.key;
      const loader = confirmRemoveBtn.querySelector('.loader');

      confirmRemoveBtn.disabled = true;
      if (loader) loader.style.display = 'inline-block';

      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
        const cart = await res.json();
        updateCartHTML(cart);
        closeWishlistPopup();
      } catch (err) {
        console.error('Failed to remove item:', err);
      } finally {
        confirmRemoveBtn.disabled = false;
        if (loader) loader.style.display = 'none';
      }
    });
  }

  function bindSelectionEvents() {
  const itemSelectContainers = document.querySelectorAll('.cart-items-selects');

  itemSelectContainers.forEach(container => {
    const iconSelect = container.querySelector('.icon-select');
    const iconSelected = container.querySelector('.icon-selectAll-active');

    // Reset state
    container.classList.remove('active-item-icon');
    iconSelect.style.display = 'block';
    iconSelected.style.display = 'none';

    iconSelect.addEventListener('click', () => {
      iconSelect.style.display = 'none';
      iconSelected.style.display = 'block';
      container.classList.add('active-item-icon');
      const drawerItem = container.closest('.cart-drawer-items');
      drawerItem?.classList.add('highlight-active-item');
      updateSelectedCount();
      updateMasterSelector?.();
    });

    iconSelected.addEventListener('click', () => {
      iconSelect.style.display = 'block';
      iconSelected.style.display = 'none';
      container.classList.remove('active-item-icon');
      const drawerItem = container.closest('.cart-drawer-items');
      drawerItem?.classList.remove('highlight-active-item');
      updateSelectedCount();
      updateMasterSelector?.();
    });
  });

  updateSelectedCount(); // Call once initially
}


  function updateMasterSelector() {
    const allItems = document.querySelectorAll('.cart-items-selects');
    const selected = Array.from(allItems).filter(item =>
      item.classList.contains('active-item-icon')
    ).length;
  
    const iconSelectSpan = document.querySelector('.icon-select-span');
    const iconSelectAllActiveSpan = document.querySelector('.icon-selectAll-active-span');
    const iconSelectActiveSpan = document.querySelector('.icon-select-active-span');
  
    if (iconSelectSpan && iconSelectAllActiveSpan && iconSelectActiveSpan) {
      iconSelectSpan.style.display = 'none';
      iconSelectAllActiveSpan.style.display = 'none';
      iconSelectActiveSpan.style.display = 'none';
  
      if (selected === 0) {
        iconSelectSpan.style.display = 'inline-block';
        deleteIconEnable.setAttribute('disabled', true);
        wishlistEnable.setAttribute('disabled', true);
      } else if (selected === allItems.length) {
        iconSelectAllActiveSpan.style.display = 'inline-block';
        deleteIconEnable.removeAttribute('disabled');
        wishlistEnable.removeAttribute('disabled');
      } else {
        iconSelectActiveSpan.style.display = 'inline-block';
        deleteIconEnable.removeAttribute('disabled');
        wishlistEnable.removeAttribute('disabled');
      }
    }
  }
  const iconSelectSpan = document.querySelector('.icon-select-span');
  const iconSelectAllActiveSpan = document.querySelector('.icon-selectAll-active-span');
  const iconSelectActiveSpan = document.querySelector('.icon-select-active-span');
  iconSelectSpan.addEventListener('click', () => {
      const allItems = document.querySelectorAll('.cart-items-selects');

      allItems.forEach(item => {
        const icon = item.querySelector('.icon-select');
        const iconActive = item.querySelector('.icon-selectAll-active');

        if (icon && iconActive) {
          icon.style.display = 'none';
          iconActive.style.display = 'block';
        }

        item.classList.add('active-item-icon');
        item.closest('.cart-drawer-items')?.classList.add('highlight-active-item');

      });
      iconSelectSpan.style.display = 'none';
      iconSelectAllActiveSpan.style.display = 'block';
      deleteIconEnable.removeAttribute('disabled');
      wishlistEnable.removeAttribute('disabled');
      updateMasterSelector(); // update master UI state
      updateSelectedCount();
    });
  iconSelectAllActiveSpan.addEventListener('click', () => {
    const allItems = document.querySelectorAll('.cart-items-selects');
    allItems.forEach(item => {
        const icon = item.querySelector('.icon-select');
        const iconActive = item.querySelector('.icon-selectAll-active');

        if (icon && iconActive) {
          icon.style.display = 'block';
          iconActive.style.display = 'none';
        }

        item.classList.remove('active-item-icon');
        item.closest('.cart-drawer-items')?.classList.remove('highlight-active-item');

      });
      iconSelectSpan.style.display = 'block';
      iconSelectAllActiveSpan.style.display = 'none';
      deleteIconEnable.setAttribute('disabled', true);
      wishlistEnable.setAttribute('disabled', true);
      updateMasterSelector();
      updateSelectedCount();
  })

  document.addEventListener('DOMContentLoaded', () => {
    // bindMasterSelectEvents();
    updateMasterSelector();
  });

  window.selectAll_Items = function () {
    const allItems = document.querySelectorAll('.cart-items-selects');
    
    allItems.forEach(item => {
      item.querySelector('.icon-select').style.display = 'none';
      item.querySelector('.icon-selectAll-active').style.display = 'block';
      deleteIconEnable.removeAttribute('disabled');
      wishlistEnable.removeAttribute('disabled');
    });
    updateMasterSelector();
  };

  window.deSelectAll_CartItems = function () {
    const allItems = document.querySelectorAll('.cart-items-selects');
    
    allItems.forEach(item => {
      item.querySelector('.icon-select').style.display = 'block';
      item.querySelector('.icon-selectAll-active').style.display = 'none';
      deleteIconEnable.setAttribute('disabled', true);
      wishlistEnable.setAttribute('disabled', true);
    });
    updateMasterSelector();
  };
  

  // open the delete items popup
  deleteIconEnable?.addEventListener('click', async () => {
    deleteConfirmPopup.style.display = 'block';
     wishlistPopupOverlay.classList.add("active");
    closeCartDrawer();
  });

   wishlistEnable?.addEventListener('click', async () => {
    deleteConfirmPopup.style.display = 'block';
  
    const hideRemoveBtn = document.querySelector('.delete-all-items-from-cart');
    if (hideRemoveBtn) hideRemoveBtn.style.display = 'none';
  
    wishlistPopupOverlay.classList.add("active");
    closeCartDrawer();
  });


   function closeDeletePopup() {
    deleteConfirmPopup.style.display = 'none';
    wishlistPopupOverlay.classList.remove("active");
   }

  deleteConfirmClosePopup?.addEventListener('click', closeDeletePopup);
  wishlistPopupOverlay?.addEventListener('click', function (event) {
    if (event.target === wishlistPopupOverlay) {
      closeDeletePopup();
    }
  });
  
  // delete all items from the cart drawer
   document.querySelector('.delete-all-items-from-cart')?.addEventListener('click', async () => {
    await deleteSelectedCartItems();
  });
  
  
  async function deleteSelectedCartItems() {
  const allCheckboxItems = document.querySelectorAll('.cart-items-selects');
  const updates = {};

  // Reference the delete button and loader inside it
  const deleteBtn = document.querySelector('.delete-all-items-from-cart');
  const loader = deleteBtn?.querySelector('.loader');

  // Show loader and disable button
  if (deleteBtn && loader) {
    deleteBtn.disabled = true;
    loader.style.display = 'inline-block';
  }

  for (const item of allCheckboxItems) {
    if (item.classList.contains('active-item-icon')) {
      const selectedItem = item.closest('.cart-drawer-items');
      const key = selectedItem.dataset.key;
      updates[key] = 0; // Set quantity to 0 to remove item
    }
  }

  if (Object.keys(updates).length === 0) {
    // Hide loader and enable button if nothing selected
    if (deleteBtn && loader) {
      loader.style.display = 'none';
      deleteBtn.disabled = false;
    }
    return;
  }

  try {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });

    const cart = await res.json();
    await updateCartHTML(cart);
    closeDeletePopup();
  } catch (err) {
    console.error('Failed to remove items:', err);
  } finally {
    // Always hide loader and re-enable button
    if (deleteBtn && loader) {
      loader.style.display = 'none';
      deleteBtn.disabled = false;
    }
  }
}


  // Move the single cart items to wishlist
  confirmMoveBtn?.addEventListener('click', async () => {
    if (!selectedItemData || !currentItemKey) {
      console.warn('Missing selectedItemData or currentItemKey');
      return;
    }
  
    const loader = confirmMoveBtn.querySelector('.loader');
    confirmMoveBtn.disabled = true;
    if (loader) loader.style.display = 'inline-block';
  
    try {
      let wishlist = JSON.parse(localStorage.getItem('user-wishlist')) || [];
  
      const handle = selectedItemData.handle || '';
      const product_id = selectedItemData.id || '';
      const title = selectedItemData.title || '';
      const image = selectedItemData.images?.[0] || selectedItemData.featured_image || '';
      const variant_id = selectedItemData.variants?.[0]?.id || '';
  
      const wishlistItem = {
        handle,
        variant_id,
        product_id,
        title,
        image,
        url: handle
      };
  
      console.log('wishlistItem:', wishlistItem);
  
      const exists = wishlist.some(item =>
        item.handle === wishlistItem.handle || item.product_id === wishlistItem.product_id
      );
  
      if (!exists) {
        wishlist.push(wishlistItem);
        localStorage.setItem('user-wishlist', JSON.stringify(wishlist));
        console.log('Updated wishlist:', wishlist);
      } else {
        console.log('Item already exists in wishlist');
      }
  
      // Remove item from cart
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: currentItemKey, quantity: 0 })
      });
  
      const cart = await (await fetch('/cart.js')).json();
      updateCartHTML(cart);
      closeWishlistPopup();
    } catch (err) {
      console.error('Error building wishlist item:', err);
    } finally {
      confirmMoveBtn.disabled = false;
      if (loader) loader.style.display = 'none';
    }
  });

  // Move all items to wishlist from the cart drawer
document.querySelector('.move-all-items-to-wishlist')?.addEventListener('click', async (e) => {
  const button = e.currentTarget;
  const loader = button.querySelector('.loader');
  
  loader.style.display = 'inline-block'; // Show loader
  button.setAttribute('disabled', true); // Disable button during processing

  const selectedIcons = document.querySelectorAll('.cart-items-selects.active-item-icon');

  if (!selectedIcons.length) {
    console.warn('No selected items to move to wishlist.');
    loader.style.display = 'none';
    button.removeAttribute('disabled');
    return;
  }

  let wishlist = JSON.parse(localStorage.getItem('user-wishlist')) || [];
  let updates = {};

  for (const icon of selectedIcons) {
    const cartItem = icon.closest('.cart-drawer-items');
    if (!cartItem) continue;

    const key = cartItem.dataset.key;
    const productJsonEl = cartItem.querySelector('[data-product-json]');
    if (!key || !productJsonEl) {
      console.warn('Missing key or product JSON:', key, productJsonEl);
      continue;
    }

    const productData = JSON.parse(productJsonEl.textContent);
    const wishlistItem = {
      handle: productData.handle || '',
      variant_id: productData.variants?.[0]?.id || '',
      product_id: productData.id || '',
      title: productData.title || '',
      image: productData.images?.[0] || productData.featured_image || '',
      url: productData.handle || ''
    };

    const alreadyInWishlist = wishlist.some(item =>
      item.product_id === wishlistItem.product_id || item.handle === wishlistItem.handle
    );

    if (!alreadyInWishlist) {
      wishlist.push(wishlistItem);
    }

    // Set quantity 0 for this key to remove
    updates[key] = 0;
  }

  // Save wishlist after processing all
  localStorage.setItem('user-wishlist', JSON.stringify(wishlist));

  if (Object.keys(updates).length === 0) {
    console.warn('No valid cart items selected for removal.');
    loader.style.display = 'none';
    button.removeAttribute('disabled');
    return;
  }

  try {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });

    if (!res.ok) {
      console.error('Failed to update cart:', res.status);
    } else {
      const updatedCart = await res.json();
      updateCartHTML(updatedCart);
      closeDeletePopup?.();
    }
  } catch (err) {
    console.error('Error updating cart:', err);
  } finally {
    loader.style.display = 'none'; // Hide loader
    button.removeAttribute('disabled'); // Re-enable button
  }
});
  
  //handleAddToCart 
  async function handleAddToCart(variantId, quantity = 1) {
    try {
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity })
      });

      if (!addRes.ok) throw new Error('Add to cart failed');

      openCartDrawer();
    } catch (err) {
      alert("Something went wrong while adding to cart");
      console.error(err);
    }
  }

  document.querySelectorAll('form[action^="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const formData = new FormData(form);
      const data = {};
      formData.forEach((value, key) => data[key] = value);
      await handleAddToCart(data.id, parseInt(data.quantity || 1));
    });
  });

  document.querySelectorAll('.js-quick-add-to-cart').forEach(button => {
    button.addEventListener('click', async e => {
      e.preventDefault();
      const variantId = button.getAttribute('data-variant-id');
      await handleAddToCart(variantId);
    });
  });

  cartButton?.addEventListener("click", e => {
    e.preventDefault();
    openCartDrawer();
  });

  cartClose?.addEventListener("click", closeCartDrawer);
  cartOverlay?.addEventListener("click", closeCartDrawer);

  // ⏱ Initial cart fetch + polling
  fetchAndUpdateCart();
  // setInterval(fetchAndUpdateCart, 5000);
});
